import { Suspense, lazy, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Route, Routes, useLocation } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

// TODO : Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Loading from './components/features/Loading';
import NotFound from './components/features/NotFound';
import PartnerHeader from './components/common/PartnerHeader';
import PartnerFooter from './components/common/PartnerFooter';

//! Auth


// Todo : Lazy Load
//! Pages
const LandingPage = lazy(() => import('./pages/landing-page'));
const BusinessOpportunity = lazy(() => import('./pages/business-opportunity'));
const USAAffiliation = lazy(() => import('./pages/usa-affiliation'));
const Remedies = lazy(() => import('./pages/remedies'));

//! Partner
const PartnerLandingPage = lazy(() => import('./pages/partner-landing-page'));

//! Generate Report
const Congratulations = lazy(() => import('./pages/generate-reports'));
const UserDetails = lazy(() => import('./pages/generate-reports/user-details'));
const ReportPayment = lazy(() => import('./pages/generate-reports/report-payment'));
const ThankYou = lazy(() => import('./pages/generate-reports/thank-you'));

//! Contents
const AboutUs = lazy(() => import('./pages/contents/about-us'));
const PrivacyPolicy = lazy(() => import('./pages/contents/privacy-policy'));
const TermsOfUse = lazy(() => import('./pages/contents/terms-of-use'));
const RefundPolicy = lazy(() => import('./pages/contents/refund-policy'));
const ShippingPolicy = lazy(() => import('./pages/contents/shipping-policy'));
const Blogs = lazy(() => import('./pages/contents/blogs'));
const BlogDetails = lazy(() => import('./pages/contents/blogs/blog-details'));

//! Eye Scan Pages
const WelcomeScan = lazy(() => import('./pages/eye-scan/WelcomeScan'));
const ScanSelect = lazy(() => import('./pages/eye-scan/ScanSelect'));
const EyeBlinkScan = lazy(() => import('./pages/eye-scan/EyeBlinkScan'));
const EyeCornerScan = lazy(() => import('./pages/eye-scan/EyeCornerScan'));
const AnalyzeScan = lazy(() => import('./pages/eye-scan/AnalyzeScan'));
const NameInputForm = lazy(() => import('./pages/eye-scan/NameInputForm'));
const ScanSuccess = lazy(() => import('./pages/eye-scan/ScanSuccess'));

const App = () => {
  const location = useLocation();

  // Scroll to top on every route change and on refresh
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Pages that should not show header/footer
  const noHeaderFooterPaths = [
    "/congratulations", 
    "/generate-reports/user-details", 
    '/generate-reports/report-payment', 
    '/generate-reports/thank-you',
    '/eyescan',
    '/scan-select',
    '/eyeai',
    '/eyeai-corner',
    '/analyze',
    '/nameInputForm',
    '/scan-success'
  ];

  // Check if this is a partner context - either /partner path OR any page with partner query params
  const searchParams = new URLSearchParams(location.search);
  const hasPartnerParams = searchParams.has('partnerId') || searchParams.has('partnerName');
  const isPartnerPath = location.pathname.startsWith("/partner") || location.pathname.startsWith("/affiliate") || hasPartnerParams;
  const hideHeaderFooter = noHeaderFooterPaths.includes(location.pathname);

  return (
    <>
      {!isPartnerPath && !hideHeaderFooter && <Header />}
      {isPartnerPath && <PartnerHeader />}

      <Suspense fallback={<Loading />}>
        <div className='min-h-[calc(100vh-160px)] text-gray-900'>
          <Routes>
            <Route path='*' element={<NotFound />} />
            {/* Page */}
            <Route path='/' element={<LandingPage />} />
            <Route path='/business-opportunity' element={<BusinessOpportunity />} />
            <Route path='/usa-affiliation' element={<USAAffiliation />} />
            <Route path='/remedies' element={<Remedies />} />
            <Route path='/partner' element={<PartnerLandingPage />} />
            <Route path='/affiliate' element={<PartnerLandingPage />} />

            {/* Generate Report */}
            <Route path='/congratulations' element={<Congratulations />} />
            <Route path='/generate-reports/user-details' element={<UserDetails />} />
            <Route path='/generate-reports/report-payment' element={<ReportPayment />} />
            <Route path='/generate-reports/thank-you' element={<ThankYou />} />

            {/* Contents */}
            <Route path='/about' element={<AboutUs />} />
            <Route path='/privacy-policy' element={<PrivacyPolicy />} />
            <Route path='/terms-of-use' element={<TermsOfUse />} />
            <Route path='/refund-policy' element={<RefundPolicy />} />
            <Route path='/shipping-policy' element={<ShippingPolicy />} />
            <Route path='/blogs' element={<Blogs />} />
            <Route path='/blogs/blog-details' element={<BlogDetails />} />

            {/* Eye Scan Routes */}
            <Route path='/eyescan' element={<WelcomeScan />} />
            <Route path='/scan-select' element={<ScanSelect />} />
            <Route path='/eyeai' element={<EyeBlinkScan />} />
            <Route path='/eyeai-corner' element={<EyeCornerScan />} />
            <Route path='/analyze' element={<AnalyzeScan />} />
            <Route path='/nameInputForm' element={<NameInputForm />} />
            <Route path='/scan-success' element={<ScanSuccess />} />
          </Routes>
        </div>
      </Suspense>

      {!isPartnerPath && !hideHeaderFooter && <Footer />}
      {isPartnerPath && <PartnerFooter />}
      <ToastContainer />
    </>
  )
}

export default App;
